export default "__VITE_ASSET__CQ$Zqudx__"